import script from "./SearchTree.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchTree.vue?vue&type=script&setup=true&lang=js"

import "./SearchTree.vue?vue&type=style&index=0&id=4d90bea0&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d90bea0"]])

export default __exports__